import { useState } from "react";
import Display from "./components/Display";
import Buttons from "./components/Buttons";
import { initialState } from "./calc";

function App() {
  const [input, setInput] = useState(initialState);

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-ink-100 to-ink-200 flex items-center justify-center px-4">
      <div className="w-calc-sm sm:w-calc-lg bg-white rounded-[28px] shadow-card border border-ink-200/70 p-6 sm:p-7">
        <div className="flex items-center justify-between mb-4 px-1">
          <span className="text-[11px] font-medium tracking-[0.18em] uppercase text-ink-400">
            Calculator
          </span>
          <span className="text-[11px] font-medium tracking-[0.18em] uppercase text-ink-400">
            JS · FCC
          </span>
        </div>
        <Display input={input} />
        <Buttons input={input} setInput={setInput} />
      </div>
    </div>
  );
}

export default App;
